import * as React from 'react'

const UploadImageIcon = (props) => (
  <svg
    width={48}
    height={48}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 21.5c-3.04 0-5.5-2.46-5.5-5.5s2.46-5.5 5.5-5.5 5.5 2.46 5.5 5.5-2.46 5.5-5.5 5.5zm0-8a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5z"
      fill="#94A3B8"
    />
    <path
      d="M30 45.5H18C7.14 45.5 2.5 40.86 2.5 30V18C2.5 7.14 7.14 2.5 18 2.5h8c.82 0 1.5.68 1.5 1.5s-.68 1.5-1.5 1.5h-8C8.78 5.5 5.5 8.78 5.5 18v12c0 9.22 3.28 12.5 12.5 12.5h12c9.22 0 12.5-3.28 12.5-12.5V20c0-.82.68-1.5 1.5-1.5s1.5.68 1.5 1.5v10c0 10.86-4.64 15.5-15.5 15.5z"
      fill="#94A3B8"
    />
    <path
      d="M42.5 11.5h-11c-.82 0-1.5-.68-1.5-1.5s.68-1.5 1.5-1.5h11c.82 0 1.5.68 1.5 1.5s-.68 1.5-1.5 1.5z"
      fill="#94A3B8"
    />
    <path
      d="M37 17c-.82 0-1.5-.68-1.5-1.5v-11c0-.82.68-1.5 1.5-1.5s1.5.68 1.5 1.5v11c0 .82-.68 1.5-1.5 1.5zM5.34 39.4c-.48 0-.96-.24-1.24-.66-.46-.68-.28-1.62.4-2.08l9.86-6.62c2.16-1.44 5.14-1.28 7.1.38l.66.58c1 .86 2.7.86 3.68 0l8.32-7.14c2.14-1.82 5.46-1.82 7.6 0l3.26 2.8c.62.54.7 1.48.16 2.12-.54.62-1.48.7-2.12.16l-3.26-2.8c-1-.86-2.7-.86-3.68 0l-8.32 7.14c-2.12 1.82-5.46 1.82-7.6 0l-.66-.58c-.92-.78-2.44-.86-3.46-.16L6.2 39.16c-.28.16-.58.24-.86.24z"
      fill="#94A3B8"
    />
  </svg>
)

export { UploadImageIcon }
